module.exports = __webpack_public_path__ + "img/icon3.481fd643.png";